import PropTypes from 'prop-types';
import { useCallback } from 'react';
// @mui
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import ImportDilaog from '../import-modal';
import { useBoolean } from 'src/hooks/use-boolean';
import { endpoints } from 'src/utils/axios';
import { useParams } from 'react-router';

// ----------------------------------------------------------------------

export default function UserTableToolbar({
    filters,
    onFilters,
    //
    roleOptions,
    reload,

}) {
    const popover = usePopover();
    const add = useBoolean();
    const { id } = useParams()
    const handleFilterName = useCallback(
        (event) => {
            onFilters('name', event.target.value);
        },
        [ onFilters ]
    );

    const handleFilterRole = useCallback(
        (event) => {
            onFilters(
                'role',
                typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value
            );
        },
        [ onFilters ]
    );

    return (
        <>
            <Stack
                spacing={ 2 }
                alignItems={ { xs: 'flex-end', md: 'center' } }
                direction={ {
                    xs: 'column',
                    md: 'row',
                } }
                sx={ {
                    p: 2.5,
                    pr: { xs: 2.5, md: 1 },
                } }
            >

                <Stack direction="row" alignItems="center" spacing={ 2 } flexGrow={ 1 } sx={ { width: 1 } }>
                    <TextField
                        fullWidth
                        value={ filters.name }
                        onChange={ handleFilterName }
                        placeholder="Search..."
                        InputProps={ {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon="eva:search-fill" sx={ { color: 'text.disabled' } } />
                                </InputAdornment>
                            ),
                        } }
                    />

                    <IconButton onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </Stack>
            </Stack>

            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >

                <MenuItem
                    onClick={ () => {
                        add.onTrue();
                    } }
                >
                    <Iconify icon="solar:import-bold" />
                    Import
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:export-bold" />
                    Export
                </MenuItem>
            </CustomPopover>
            <ImportDilaog
                open={ add.value }
                onClose={ add.onFalse }
                reload={ reload }
                url={ `${endpoints.admin_dashboard.teachnical_database.cost_codes.import_activities}/${id}/import-cost-codes` }
                fileName="csv_file"

            />
        </>
    );
}

UserTableToolbar.propTypes = {
    filters: PropTypes.object,
    onFilters: PropTypes.func,
    roleOptions: PropTypes.array,
};
